import React, { useState } from 'react';

const TabBar = ({ tabs, activeTab, setActiveTab, setTabs, dark }) => {
  const [editingTab, setEditingTab] = useState(null);
  const [editName, setEditName] = useState('');

  const bg      = dark ? '#111827' : '#f0f4f8';
  const tabBg   = dark ? '#1a2236' : '#e2e8f0';
  const actBg   = dark ? '#0f1624' : '#ffffff';
  const text    = dark ? '#8899bb' : '#64748b';
  const actText = dark ? '#e2e8f0' : '#1e293b';
  const border  = dark ? '#1e2843' : '#cbd5e1';
  const accent  = '#3b82f6';

  const handleAddTab = () => {
    const id = `custom_${Date.now()}`;
    const newTabs = [...tabs, { id, name: `Sheet${tabs.length + 1}` }];
    setTabs(newTabs);
    setActiveTab(id);
  };

  const handleCloseTab = (e, tabId) => {
    e.stopPropagation();
    if (tabs.length <= 1) return;
    const filtered = tabs.filter(t => t.id !== tabId);
    setTabs(filtered);
    if (activeTab === tabId) setActiveTab(filtered[0].id);
  };

  const startRename = (tab) => {
    setEditingTab(tab.id);
    setEditName(tab.name);
  };

  const saveRename = () => {
    setTabs(tabs.map(t => t.id === editingTab ? { ...t, name: editName.trim() || 'Untitled' } : t));
    setEditingTab(null);
  };

  // Sheet icon depending on name
  const sheetIcon = (name) => {
    if (name === 'Summary') return '📋';
    if (name === 'Sales Data') return '📈';
    return '📄';
  };

  return (
    <div style={{ display: 'flex', alignItems: 'stretch', height: '36px', background: bg, borderTop: `1px solid ${border}`, overflow: 'hidden' }}>
      
      {/* Scrollable tab area */}
      <div style={{ display: 'flex', alignItems: 'stretch', overflowX: 'auto', flex: 1, scrollbarWidth: 'none' }}>
        {tabs.map(tab => {
          const isActive = tab.id === activeTab;
          return (
            <div
              key={tab.id}
              onClick={() => setActiveTab(tab.id)}
              onDoubleClick={() => startRename(tab)}
              style={{
                display: 'flex', alignItems: 'center', gap: '4px',
                padding: '0 14px',
                minWidth: '110px', maxWidth: '180px',
                background: isActive ? actBg : tabBg,
                color: isActive ? actText : text,
                borderRight: `1px solid ${border}`,
                borderTop: isActive ? `2px solid ${accent}` : '2px solid transparent',
                cursor: 'pointer',
                fontSize: '12px',
                fontWeight: isActive ? '600' : '400',
                transition: 'background 0.15s, color 0.15s',
                userSelect: 'none',
                position: 'relative',
                flexShrink: 0,
                boxSizing: 'border-box',
              }}
              onMouseEnter={e => { if (!isActive) e.currentTarget.style.background = dark ? '#1f2d46' : '#e8ecf0'; }}
              onMouseLeave={e => { if (!isActive) e.currentTarget.style.background = tabBg; }}
            >
              {editingTab === tab.id ? (
                <input
                  value={editName}
                  onChange={e => setEditName(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') saveRename(); if (e.key === 'Escape') setEditingTab(null); }}
                  onBlur={saveRename}
                  autoFocus
                  style={{
                    width: '100%', border: `1px solid ${accent}`, borderRadius: '3px',
                    background: 'transparent', color: actText, fontSize: '11.5px',
                    outline: 'none', padding: '1px 4px',
                  }}
                  onClick={e => e.stopPropagation()}
                />
              ) : (
                <>
                  <span style={{ fontSize: '13px' }}>{sheetIcon(tab.name)}</span>
                  <span style={{ flex: 1, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', fontSize: '11.5px' }}>{tab.name}</span>
                  {tabs.length > 1 && isActive && (
                    <button
                      onClick={e => handleCloseTab(e, tab.id)}
                      style={{
                        width: '14px', height: '14px', borderRadius: '50%',
                        background: 'rgba(100,116,139,0.2)', border: 'none',
                        cursor: 'pointer', color: text, fontSize: '9px',
                        display: 'flex', alignItems: 'center', justifyContent: 'center',
                        flexShrink: 0, lineHeight: 1,
                        transition: 'background 0.15s',
                      }}
                      onMouseEnter={e => e.currentTarget.style.background = 'rgba(239,68,68,0.2)'}
                      onMouseLeave={e => e.currentTarget.style.background = 'rgba(100,116,139,0.2)'}
                    >
                      ×
                    </button>
                  )}
                </>
              )}
            </div>
          );
        })}

        {/* Add Sheet button */}
        <button
          onClick={handleAddTab}
          title="Add new sheet"
          style={{
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            width: '36px', flexShrink: 0,
            background: 'transparent', border: 'none', borderRight: `1px solid ${border}`,
            cursor: 'pointer', color: text, fontSize: '18px', lineHeight: 1,
            transition: 'background 0.15s',
          }}
          onMouseEnter={e => e.currentTarget.style.background = dark ? '#1f2d46' : '#e2e8f0'}
          onMouseLeave={e => e.currentTarget.style.background = 'transparent'}
        >
          +
        </button>
      </div>

      {/* Status area */}
      <div style={{
        display: 'flex', alignItems: 'center', gap: '12px',
        padding: '0 14px', borderLeft: `1px solid ${border}`,
        fontSize: '11px', color: text, flexShrink: 0,
      }}>
        <span style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
          <span style={{ width: '6px', height: '6px', borderRadius: '50%', background: '#10b981', display: 'inline-block' }} />
          Ready
        </span>
        <span>{tabs.length} {tabs.length === 1 ? 'sheet' : 'sheets'}</span>
      </div>
    </div>
  );
};

export default TabBar;
